import {
    ItemsScope,
    ItemsCommandBar,
    ItemCacheProvider,
    ControlHandlerProvider,
    itemsCommandBarControl,
    IItemCache,
    getItemsScope,
    selectedItemsFacet,
} from '@ms/items-view';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getParameterStore } from '../store/ParametersStore';
import { itemCacheStore, getItemScopeItemKey } from '../store/cache';
import {
    downloadCommand,
    printCommand,
    isDateRangeOptionSelectedCheck,
    isExtensionSelected,
    isExtensionFilterExpanded,
    openInNewTabCommand,
} from '../utils/getCommandBarActions';
import { getFilterContextMenu, FilesFilterContextMenuType } from 'owa-files-filter-contextmenu';
import { fileKeyFacet } from '../Schema/Facets';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { AttachmentModel, TypeOfAttachment } from 'owa-attachment-model-store';

export const FilesViewCommandBar = observer(function FilesViewCommandBar(props: {}) {
    const filterContextMenu = getFilterContextMenu(
        FilesFilterContextMenuType.GroupView,
        isDateRangeOptionSelectedCheck,
        isExtensionSelected,
        isExtensionFilterExpanded
    );

    const itemsCommandBarControlHandler = (
        itemCache: IItemCache,
        props: typeof itemsCommandBarControl.inputType
    ): typeof itemsCommandBarControl.returnType => {
        const { itemsScopeItemKey } = getItemsScope(itemCache);

        const selectedItems = itemCache.demandItemFacet(selectedItemsFacet, itemsScopeItemKey);
        const selectedItemKeys = selectedItems && selectedItems.itemKeys;
        const hasSelection = selectedItemKeys && selectedItemKeys.length > 0;

        const parameterStore = getParameterStore();

        if (hasSelection) {
            for (const itemKey of selectedItemKeys) {
                const { id } = itemCache.demandItemFacet(fileKeyFacet, itemKey);
                const attachmentId = {
                    Id: id,
                    mailboxInfo: parameterStore.mailboxInfo,
                };
                const attachment: AttachmentModel = getAttachment(attachmentId);
                if (attachment.type === TypeOfAttachment.Link) {
                    return {
                        commands: [openInNewTabCommand],
                    };
                }
            }
        }

        return {
            commands: hasSelection ? [downloadCommand, printCommand] : [filterContextMenu],
        };
    };

    return (
        <ItemCacheProvider
            store={itemCacheStore}
            key={`${getParameterStore().mailboxInfo &&
                getParameterStore().mailboxInfo.deprecatedMailboxId}-cmdbar`}>
            <ItemsScope itemsScopeItemKey={getItemScopeItemKey()}>
                <ControlHandlerProvider
                    controlHandlers={{
                        ...itemsCommandBarControl.pack(itemsCommandBarControlHandler),
                    }}>
                    <ItemsCommandBar />
                </ControlHandlerProvider>
            </ItemsScope>
        </ItemCacheProvider>
    );
});
